if (!customElements.get("cart-drawer")) {
class CartDrawer extends HTMLElement {
  static editorOpenSections = new Set();
  constructor() {
    super();
    this.openedBy = null;
    this.overlay = null;
    this.panel = null;
    this.closeButtons = [];
    this._focusTrap = null;
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onEditorSelect = this.onEditorSelect.bind(this);
    this.onEditorDeselect = this.onEditorDeselect.bind(this);
  }

  connectedCallback() {
    this.overlay = this.querySelector("[data-cart-drawer-overlay]");
    this.panel = this.querySelector("[data-cart-drawer-panel]");
    this.closeButtons = Array.from(
      this.querySelectorAll("[data-cart-drawer-close]"),
    );

    if (this.overlay) {
      this.overlay.addEventListener("click", this.onCloseClick);
    }
    this.closeButtons.forEach((button) =>
      button.addEventListener("click", this.onCloseClick),
    );
    if (window.Shopify?.designMode) {
      document.addEventListener("shopify:section:select", this.onEditorSelect);
      document.addEventListener("shopify:section:deselect", this.onEditorDeselect);
      if (CartDrawer.editorOpenSections.has(this.dataset.sectionId)) this.show();
    }
  }

  disconnectedCallback() {
    document.removeEventListener("shopify:section:select", this.onEditorSelect);
    document.removeEventListener("shopify:section:deselect", this.onEditorDeselect);
    const wasOpen = this.hasAttribute("open");
    this.openedBy = null;
    if (wasOpen) this.hide();
    if (window.Shopify?.designMode && wasOpen) {
      CartDrawer.editorOpenSections.add(this.dataset.sectionId);
    }
    if (this.overlay) {
      this.overlay.removeEventListener("click", this.onCloseClick);
    }
    this.closeButtons.forEach((button) =>
      button.removeEventListener("click", this.onCloseClick),
    );
  }

  onEditorSelect(event) {
    if (event.detail?.sectionId === this.dataset.sectionId) this.show();
  }

  onEditorDeselect(event) {
    if (event.detail?.sectionId === this.dataset.sectionId) this.hide();
  }

  onCloseClick() {
    this.hide();
  }

  show(opener) {
    if (!this.isConnected) return;
    this.openedBy = opener || null;
    this.setAttribute("open", "");
    document.documentElement.classList.add("overflow-hidden");
    if (this.overlay) {
      this.overlay.classList.add("opacity-100");
      this.overlay.classList.remove("opacity-0");
    }
    if (this.panel) {
      this.panel.classList.add("!translate-x-0");
    }
    this.classList.remove("pointer-events-none");
    if (!this._focusTrap) {
      this._focusTrap = webvista.createFocusTrap(this, {
        onEscape: this.onCloseClick,
      });
    }
    this.addEventListener("keydown", this._focusTrap);
    webvista.focusFirstElement(this);
  }

  hide() {
    CartDrawer.editorOpenSections.delete(this.dataset.sectionId);
    this.removeAttribute("open");
    document.documentElement.classList.remove("overflow-hidden");
    if (this.overlay) {
      this.overlay.classList.remove("opacity-100");
      this.overlay.classList.add("opacity-0");
    }
    if (this.panel) {
      this.panel.classList.remove("!translate-x-0");
    }
    this.classList.add("pointer-events-none");
    if (this._focusTrap) {
      this.removeEventListener("keydown", this._focusTrap);
    }
    if (
      this.openedBy &&
      typeof this.openedBy.focus === "function" &&
      document.body.contains(this.openedBy)
    ) {
      this.openedBy.focus();
    }
  }
}

customElements.define("cart-drawer", CartDrawer);
}
